import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import store from '../store';
export default function getPageTitle(pageTitle) {
  var title = store.state.app.grant.name || '聚全信息';
  if (pageTitle) {
    return "".concat(pageTitle, " - ").concat(title);
  }
  return "".concat(title);
}